import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { SessionStateService } from "../../core/services/session-state.service";
import { EnergyService } from "./energy.service";
import { GeneralService } from "../../shared/services/general.service";
import { DevicesService } from "../devices/devices.service";
import { HousesService } from "../houses/houses.service";
import { Device } from "../devices/devices.model_new";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable } from "rxjs";
import { empty } from "rxjs/observable/empty";
import { take } from "rxjs/operators";
import { of } from "rxjs/observable/of";

const REPORTS_NAVIGATION_NAME = "REPORTS";

@Component({
  selector: "app-energy",
  templateUrl: "./energy.component.html",
  styleUrls: ["./energy.component.scss"],
})
export class EnergyComponent implements OnInit {
  clientHasGas = false;
  clientHasElectricity = false;
  clientHasGeneration = false;
  loaded = true;
  clientType: string;
  serviceSubscriptions: Map<String, String>;
  viewMode = "kWh";
  gasMeterID: String = "";
  menu = [];
  hasType: boolean;
  smartMeterID: string;

  constructor(
    private route: ActivatedRoute,
    private sessionStateService: SessionStateService,
    private energyService: EnergyService,
    private housesServices: HousesService,
    private devicesService: DevicesService,
    private router: Router
  ) {}
  ngOnInit() {
    this.route.queryParams.pipe(take(1)).subscribe((values) => {
      const redirectedEnergyType = values ? values.energyType : undefined;
      const redirectedHouseId = values ? values.houseId : undefined;
      const currentHouseId = this.sessionStateService.getHouse().houseId;

      // Redirecting directly to reports but to another house => change of house must occur, so
      // the logic of this component must be stopped (the change will occur automatically in sidebar-layout)
      if (
        redirectedEnergyType === REPORTS_NAVIGATION_NAME &&
        redirectedHouseId !== currentHouseId
      ) {
        return;
      }

      this.loadMenus();
    });
  }

  viewModeEur() {
    this.viewMode = "Eur";
  }

  viewModekWh() {
    this.viewMode = "kWh";
  }

  changeTab(event) {
    this.hasType = event;
  }

  loadMenus() {
    this.devicesService
      .getSmartMeter(this.sessionStateService.getHouse().houseId)
      .map(
        (meter) => {
          if (meter.length === 0) {
            this.router.navigate(["/energy/no-smart-meter"]);
          }
          this.clientHasElectricity = true;
        },
        (err) => {
          this.router.navigate(["/energy/no-smart-meter"]);
        }
      )
      .catch((err) => this.router.navigate(["/energy/no-smart-meter"]))
      .flatMap(() =>
        this.devicesService
          .getGasMeter(this.sessionStateService.getHouse().houseId)
          .map((gasMeter: Device) => {
            if (gasMeter) {
              this.gasMeterID = gasMeter ? gasMeter.getModuleLocalId() : "";
              this.clientHasGas = true;
            } else {
              this.clientHasGas = false;
            }
          })
          .catch((e: any) => of(empty))
          .finally(() => {
            if (
              this.energyService.isAutoConsumption() ||
              this.energyService.isAutoConsumptionWithBattery() ||
              this.energyService.isCommunity()
            ) {
              this.menu.push("CONSUMPTION AND GENERATION");
              this.clientHasGeneration = true;
            } else {
              if (this.clientHasGas) {
                this.menu.push("GAS CONSUMPTION");
              }
              if (this.clientHasElectricity && this.clientHasGas) {
                this.menu.push("ELECTRICITY CONSUMPTION");
              } else {
                this.menu.push("CONSUMPTION");
              }
            }
            if (this.energyService.isMicroGeneration()) {
              this.menu.push("GENERATION");
              this.clientHasGeneration = true;
            }
            this.menu.push("PREDICTION");
            this.menu.push("POWER");
            this.menu.push("REPORTS");
            this.loaded = true;
          })
      )
      .subscribe();
  }
  public getEnergy() {
    return this.energyService;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/energy/energy.component.ts